import React from 'react';

const End = () => {
  return (
    <div className='bg-gray-800 py-8 px-6 text-white text-center md:flex justify-between items-center'>
      <div className="md:w-2/3 ">
        <p className='text-xl mb-4 text-white'>Designed by Varun Walwatkar</p>
        
      
        
        
        
      </div>
      <div className="md:w-1/3 mt-6 md:mt-0">
       
      </div>
    </div>
  );
}

export default End;
